import { render, staticRenderFns } from "./GloboGraphicsModulo.vue?vue&type=template&id=144dc660&scoped=true"
import script from "./GloboGraphicsModulo.vue?vue&type=script&lang=js"
export * from "./GloboGraphicsModulo.vue?vue&type=script&lang=js"
import style0 from "./GloboGraphicsModulo.vue?vue&type=style&index=0&id=144dc660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144dc660",
  null
  
)

export default component.exports